export default __webpack_public_path__ + "static/media/Clock.93d9cd08.svg";